import { DetailedGeneralRequest, PaginatedResponse } from "../types/request";

export interface GeneralRequestParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  category?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export interface UpdateStatusParams {
  status: string;
  completedAt?: string;
}

export const createGeneralRequestsApi = (
  callApi: (config: any) => Promise<any>
) => {
  return {
    /**
     * Fetch general requests with pagination and filtering
     */
    async fetchGeneralRequests(
      params: GeneralRequestParams
    ): Promise<PaginatedResponse<DetailedGeneralRequest>> {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.search) queryParams.append("search", params.search);
      if (params.status) queryParams.append("status", params.status);
      if (params.category) queryParams.append("category", params.category);
      if (params.sortBy) queryParams.append("sortBy", params.sortBy);
      if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

      const response = await callApi({
        method: "GET",
        url: `/management/general?${queryParams.toString()}`,
      });

      return response.data;
    },

    /**
     * Fetch a specific general request by ID
     */
    async fetchGeneralRequestById(
      requestId: string
    ): Promise<DetailedGeneralRequest> {
      const response = await callApi({
        method: "GET",
        url: `/management/general/${requestId}`,
      });

      return response.data;
    },

    /**
     * Update general request status
     */
    async updateGeneralRequestStatus(
      requestId: string,
      params: UpdateStatusParams
    ): Promise<DetailedGeneralRequest> {
      const response = await callApi({
        method: "PUT",
        url: `/management/general/${requestId}/status`,
        data: params,
      });

      return response.data;
    },
  };
};

export type GeneralRequestsApi = ReturnType<typeof createGeneralRequestsApi>;
